import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { componentsItemMap } from '../../library/children';
import { Box } from '../Box/Box';
export const FlexViewContext = React.createContext({
    componentItem: 'div',
});
export const Container = ({ children, itemsJustifyContent, itemsAlignItems, component, ...allBoxProps }) => {
    return (_jsx(Box, { display: "flex", ...allBoxProps, component: component, children: _jsx(FlexViewContext.Provider, { value: {
                justifyContent: itemsJustifyContent,
                alignItems: itemsAlignItems,
                componentItem: componentsItemMap[component ?? 'div'],
            }, children: children }) }));
};
